import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import ServiceProvider from './index';

function ServiceProviderWrapper(props) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    // clear previous render
    ref.current.innerHTML = '';

    const svg = ServiceProvider(props);

    ref.current.appendChild(svg);
  }, [props]);

  return (
    <Box
      sx={{
        cursor: props?.disabled ? 'default' : 'pointer',
        display: 'flex',
        alignItems: 'center',
      }}
      ref={ref}
    />
  );
}

export default ServiceProviderWrapper;
